import { FilterOption } from '#service/autocomplete-service/option';

class WarehouseAppliancesOptionService {
  getOptionsRaw() {
    return [
      { label: 'All', value: 'all', id: '0', default: true },
      { label: 'With appliances', value: 'withAppliance', id: '1' },
      { label: 'Empty', value: 'empty', id: '2' }
    ];
  }

  async fetchOptionsRaw(value, fetchOptions, ids) {
    const options = this.getOptionsRaw();

    if (ids) {
      const idsArray = ids.length > 1 ? ids.join(',') : [ids];
      const filteredArray = options.filter(option => idsArray.includes(option.id));

      return filteredArray;
    }

    return options;
  }

  async getOptions(value, fetchOptions, ids) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, ids);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options.map(option => {
      const label = `${option.label}`;
      return new FilterOption(option, label);
    });
  }
}

export default WarehouseAppliancesOptionService;
